import AiGlobalExecutionSettingsPage from "../../pages/aiDevelopment/AiGlobalExecutionSettingsPage";
const route={key:"aiGlobalExecutionSettings",path:"/ai-development/execution-settings",component:AiGlobalExecutionSettingsPage,permission:"ai.development.admin",private:true,layout:"main",icon:"faSliders",group:"aiDevelopment",order:21};
export default route;
